export default function prepareComparator<T>(keyToCompare: keyof T) {
  return function comparator(objA:any, objB:T) {
    return objA[keyToCompare].localeCompare(objB[keyToCompare]);
  };
}
